import React from "react";
import { Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";

const RecordNavigator = ({ records, currentId, basePath }) => {

    if (!Array.isArray(records) || records.length === 0) return null;

    const currentIndex = records.findIndex((record) => record.id === Number(currentId));
    const prevRecord = records[currentIndex - 1];
    const nextRecord = records[currentIndex + 1];

    return (
        <Box sx={{ display: "flex", gap: 2 }}>
            <Typography variant="body2" sx={{ color: prevRecord ? "#1976d2" : "gray" }}>
                {prevRecord ? (
                    <Link to={`${basePath}/${prevRecord.id}`} state={{ records }} style={{ textDecoration: "none", color: "inherit" }}>
                        ← Previous
                    </Link>
                ) : (
                    "← Previous"
                )}
            </Typography>

            <Typography variant="body2" sx={{ color: nextRecord ? "#1976d2" : "gray" }}>
                {nextRecord ? (
                    <Link to={`${basePath}/${nextRecord.id}`} state={{ records }} style={{ textDecoration: "none", color: "inherit" }}>
                        Next →
                    </Link>
                ) : (
                    "Next →"
                )}
            </Typography>
        </Box>
    );
};

export default RecordNavigator;